/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeaturesearchembeddings3Inputs */

const en_aifeaturesearchembeddings3 = /** @type {(inputs: Aifeaturesearchembeddings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by meaning`)
};

const de_aifeaturesearchembeddings3 = /** @type {(inputs: Aifeaturesearchembeddings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche nach Bedeutung`)
};

/**
* | output |
* | --- |
* | "Search by meaning" |
*
* @param {Aifeaturesearchembeddings3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeaturesearchembeddings3 = /** @type {((inputs?: Aifeaturesearchembeddings3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeaturesearchembeddings3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeaturesearchembeddings3(inputs)
	return de_aifeaturesearchembeddings3(inputs)
});
export { aifeaturesearchembeddings3 as "aiFeatureSearchEmbeddings" }